// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"56":"bef414e4","62":"442895e0","141":"8ff132eb","161":"d61e6112","166":"4c87d7ea","210":"b9ad9ffb","348":"f4de2ef7","413":"641408e5","496":"73b319f5","553":"f0cb8536","617":"5740edb8","651":"c7b67732","787":"9e47f200","791":"afa599f1","833":"f4f1c4db","923":"1a528b86"}[chunkId] + ".js";
};